import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const OutfitDetailPage = lazy(
  () =>
    import('./OutfitDetailPage.eager').then(mod => ({
      default: mod.OutfitDetailPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
